import { Create_site_acceptedLocales } from '__generated__/Create';
import CreateContext from 'projects/components/CreateContext';
import * as React from 'react';

interface Props {
    locales: Create_site_acceptedLocales[];
}

const LocaleSwitcher: React.SFC<Props> = ({ locales }) => (
    <div className="locale-switcher">
        <span className="locale-switcher__icon">
            <span className="icon icon--globe-1" />
        </span>
        <div className="locale-switcher__nav">
            <ul className="footer-level-nav">
                {locales.map(locale => (
                    <li className="footer-level-nav__item" data-state="selected" key={locale.tag}>
                        <a
                            className="footer-level-nav__item__link"
                            href={`/user/switch-language/${locale.tag}`}
                        >
                            {locale.title}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    </div>
);

class SiteFooter extends React.Component {
    render() {
        return (
            <div className="site-footer">
                <div className="site-footer__sub__inner">
                    <div className="site-footer__legal">
                        <span className="site-footer__legal__copyright-message">
                            &copy; 99designs
                        </span>
                        <div className="site-footer__legal__privacy-links">
                            <ul className="footer-level-nav">
                                <li className="footer-level-nav__item">
                                    <a
                                        className="footer-level-nav__item__link"
                                        target="_blank"
                                        href="/legal/terms-of-use"
                                    >
                                        {__('Terms')}
                                    </a>
                                </li>
                                <li className="footer-level-nav__item">
                                    <a
                                        className="footer-level-nav__item__link"
                                        target="_blank"
                                        href="/legal/privacy"
                                    >
                                        {__('Privacy')}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="site-footer__language">
                        <CreateContext.Consumer>
                            {({ site }) =>
                                site && Object.keys(site!.acceptedLocales).length ? (
                                    <LocaleSwitcher locales={site!.acceptedLocales} />
                                ) : (
                                    ''
                                )
                            }
                        </CreateContext.Consumer>
                    </div>
                </div>
            </div>
        );
    }
}

export default SiteFooter;
